<template>
  <a-layout class='index animated fadeIn'>
    <SmallSquare content='数据统计到昨日数据，数据每天00：00自动更新' :padding='true'></SmallSquare>
    <a-card :bordered='false'>
      <a-form ref='form' :model='search' :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="" name='keyword' style="width:300px">
          <a-input-group compact>
            <a-select v-model:value="search.key_type">
              <a-select-option value="id">活动ID</a-select-option>
              <a-select-option value="activity_name">活动名称</a-select-option>
            </a-select>
            <a-input style="width: 70%" v-model:value="search.keyword" placeholder="请输入关键词进行搜索"/>
          </a-input-group>
        </a-form-item>
        <a-form-item label="活动时间" name='time'>
          <a-range-picker valueFormat='YYYY-MM-DD ' format='YYYY-MM-DD' @change="onChange" v-model:value="time" />
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
      </a-form>
      <div class='m-t-20'>
        <a-table :pagination='false' :loading='listLoading' bordered :columns='columns' :data-source='list'>
          <template #scanNum>
            <span>
              扫码次数
              <a-tooltip placement="right" :auto-adjust-overflow="false">
                <template #title>
                  <p>扫码参与活动的总次数，包含重复领奖次数</p>
                </template>
                <InfoCircleOutlined />
              </a-tooltip>
            </span>
          </template>
          <template #awardTime>
            <span>
              中奖次数
              <a-tooltip placement="right" :auto-adjust-overflow="false">
                <template #title>
                  <p>首次扫码的次数，包含首次扫码不中奖的次数</p>
                </template>
                <InfoCircleOutlined />
              </a-tooltip>
            </span>
          </template>
          <template #awardUser>
            <span>
              中奖人数
              <a-tooltip placement="right" :auto-adjust-overflow="false">
                <template #title>
                  <p>首次扫码的人数，包含不中奖的人数，去重</p>
                </template>
                <InfoCircleOutlined />
              </a-tooltip>
            </span>
          </template>

          <template #priority>
            <span>
              开奖率
              <a-tooltip placement="right" :auto-adjust-overflow="false">
                <template #title>
                  <p>活动设置的奖项被领取的占比，中奖次数/活动总码数</p>
                </template>
                <InfoCircleOutlined />
              </a-tooltip>
            </span>
          </template>
          <template v-slot:scanNumContent="{record}">
            {{record.scan_total}}
          </template>
          <template v-slot:awardTimeContent="{record}">
            {{record.award_number}}
          </template>
          <template v-slot:awardUserContent="{record}">
            {{record.award_user}}
          </template>
          <template v-slot:priorityContent="{record}">
            {{record.award_plan}}
          </template>
          <template v-slot:position="{record}">
            <p>{{record.city}}</p>
            <p>{{record.area}}</p>
          </template>
          <template v-slot:code_sn="{ record }">
            <p>{{record.product_code}}</p>
            （{{record.code_sn}}）
          </template>
          <template v-slot:award_content_arr="{ record }">
            <div v-if='record.award_content_arr.length'>
              <p v-for="(item,index) in record.award_content_arr" :key='index'>{{item}}</p>
            </div>
            <p v-else>-</p>
          </template>
          <template v-slot:action="{ record }">
            <a href="javascript:;" v-has:guideStatisticsActivityDetail="()=>{$router.push({path:'/guide/statistics/detail',query:{activity_id:record.activity_id,activity_name:record.activity_name}})}">详情</a>
          </template>
        </a-table>
        <a-pagination :show-total="total => `总数:${total} `" :style="{marginTop:'10px',textAlign:'right'}" show-size-changer show-quick-jumper :current="search.page" :page-size="search.limit" :total="total" @change="pageCurrentChange" @showSizeChange="pageSizeChange" />
      </div>
    </a-card>
  </a-layout>
</template>
<script>
import { reactive, ref, toRefs, onMounted, inject } from "vue";
import { DownOutlined } from "@ant-design/icons-vue";
import { iscode } from "@/utils/app";
import { guide_activity_statistical } from "@/api/guide";
import { message } from "ant-design-vue";
import { InfoCircleOutlined } from "@ant-design/icons-vue";
const def = {
  page: 1,
  page_num: 10,
  key_type: "id",
  keyword: "",
  start_time: "",
  end_time: "",
};
export default {
  name: "award",
  components: { InfoCircleOutlined },
  setup() {
    const state = reactive({
      vipList: [],
      listLoading: false,
      total: 0,
      visible: false,
      time: [],
      totalData: {},
      scan_id: "",
      showMore: false,
    });
    let list = ref();

    let columns = [
      {
        title: "活动ID",
        dataIndex: "activity_id",
        key: "activity_id",
      },
      {
        title: "活动名称",
        dataIndex: "activity_name",
        key: "activity_name",
      },
      {
        title: "活动时间",
        dataIndex: "created_time",
        key: "created_time",
        width: 200,
      },
      {
        key: "scan_total",
        slots: { title: "scanNum", customRender: "scanNumContent" },
      },
      {
        key: "awardTime",
        slots: { title: "awardTime", customRender: "awardTimeContent" },
      },
      {
        key: "awardUser",
        slots: { title: "awardUser", customRender: "awardUserContent" },
      },
      {
        key: "priority",
        slots: { title: "priority", customRender: "priorityContent" },
      },
      {
        title: "操作",
        key: "action",
        width: 100,
        fixed: "right",
        slots: { customRender: "action" },
      },
    ];
    const initData = async () => {
      state.listLoading = true;
      let res = await guide_activity_statistical(search.value).then(
        (res) => res.data
      );
      state.listLoading = false;
      if (iscode(res)) {
        list.value = res.data.data;
        state.total = res.data.total;
      }
      state.listLoading = false;
    };
    const search = ref({ ...def });
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    onMounted(() => {
      initData(search.value);
    });
    const $router = inject("$router");
    // 时间筛选
    const onChange = (e) => {
      if (!e) {
        search.value.start_time = "";
        search.value.end_time = "";
        return;
      }
      search.value.start_time = e[0];
      search.value.end_time = e[1];
    };
    // 活动弹窗
    const activityVisible = ref(false);
    const activitySelect = (data) => {
      search.value.activity_id = data.activity_id;
      search.value.activity_name = data.activity_name;
      activityVisible.value = false;
    };
    // 商品弹窗
    const productVisible = ref(false);
    const goodSelect = (data) => {
      search.value.product_name = data.product_name;
      search.value.product_id = data.id;
      productVisible.value = false;
    };
    // 选择省市区
    const citychange = (e) => {
      search.value.province_id = e[0] || "";
      search.value.city_id = e[1] || "";
      search.value.district_id = e[2] || "";
    };
    // 切换是否中奖
    const changIsAward = (e) => {
      if (e == 0) {
        search.value.award_status = "";
      }
    };

    return {
      ...toRefs(state),
      search,
      list,
      columns,
      pageSearchChange,
      pageCurrentChange,
      pageSizeChange,
      onChange,
      activityVisible,
      activitySelect,
      productVisible,
      goodSelect,
      citychange,
      changIsAward,
    };
  },
};
</script>